var _path, _path2, _g, _g2, _g3, _g4, _path3, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJupiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 288,
    viewBox: "0 0 245 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.424 226.859C217.191 193.092 217.191 138.344 183.424 104.577C149.656 70.8092 94.9085 70.8092 61.1412 104.577C27.3738 138.344 27.3738 193.092 61.1412 226.859C94.9085 260.626 149.656 260.626 183.424 226.859Z",
    fill: "url(#paint0_linear_1023_9909)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.216 252.19C170.967 251.665 209.251 212.529 208.726 164.778C208.201 117.026 169.065 78.742 121.314 79.267C73.5628 79.7921 35.2783 118.928 35.8034 166.679C36.3285 214.431 75.4643 252.715 123.216 252.19Z",
    fill: "url(#paint1_radial_1023_9909)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.49 80.2084C111.094 87.0445 116.896 96.2456 123.493 101.971C141.608 117.692 171.403 114.485 188.503 110.243C187.364 108.96 186.186 107.716 184.97 106.509C174.151 106.921 157.645 106.327 143.235 99.5966C133.259 94.9339 123.502 86.4318 116.953 79.5669C114.1 79.6435 111.276 79.8637 108.49 80.2084Z",
    fill: "#CEAC94"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0547 89.0456C90.1451 103.685 106.766 126.089 132.177 134.342C157.472 142.567 185.842 134.601 200.328 128.329C199.657 127.037 198.949 125.754 198.221 124.49C190.476 126.003 178.153 127.985 166.137 127.228C133.354 125.17 105.167 106.519 84.8887 87.7339C83.9313 88.1552 82.993 88.586 82.0547 89.036V89.0456Z",
    fill: "#CEAC94"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9484 113.834C55.026 120.651 58.3962 128.617 62.6664 135.137C92.2227 180.271 175.836 188.495 208.322 171.807C208.351 170.85 208.37 169.883 208.37 168.916C208.37 161.85 208.495 154.564 206.915 147.976C200.289 148.867 191.395 150.954 183.524 151.72C135.92 156.345 94.1471 127.21 85.578 120.919C76.4823 114.246 69.1866 106.988 64.0643 101.904C59.8611 105.476 56.4143 109.526 52.9579 113.834H52.9484Z",
    fill: "#CEAC94"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0261 151.059C60.6175 173.837 130.741 231.772 171.604 236.932C185.985 225.443 192.764 217.946 199.083 205.519C189.24 193.426 153.624 197.39 111.458 185.642C73.5526 175.072 49.9229 156.469 37.7538 146.914C37.5431 147.842 37.1985 150.121 37.0261 151.059Z",
    fill: "#CEAC94"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8303 184.694C38.3186 187.883 39.4771 190.468 40.3005 193.541L42.2537 198.683C49.425 208.717 53.7622 212.719 66.9462 222.58C96.3971 244.611 124.23 248.738 143.494 249.743C146.443 248.766 150.426 247.78 153.221 246.507C140.526 243.826 118.093 239.901 88.3929 223.404C65.4526 210.66 50.8324 198.012 37.8303 184.694Z",
    fill: "#CEAC94"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_9909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.322 16.63C35.9699 26.8693 59.0657 52.8074 59.0657 52.8074L57.3348 54.4263C57.3348 54.4263 29.5327 22.6072 29.667 15.4163L32.322 16.63Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8653 29.7499C29.7743 37.3878 52.1422 59.2829 52.1422 59.2829L53.8731 57.664C53.8731 57.664 25.0348 28.6897 17.8317 27.0197L18.8653 29.7499Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3837 58.1218L57.1669 54.5834C57.1669 54.5834 29.6251 26.1902 29.7941 18.1728C29.9632 10.1554 26.1341 24.8 26.1341 24.8L18.5803 27.0591C18.5803 27.0591 35.715 38.5134 40.6236 43.4248C48.941 51.7614 53.391 58.1149 53.391 58.1149L53.3837 58.1218Z",
    fill: "#C80923",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7658 54.023C57.7658 54.023 32.5612 27.2503 29.6913 15.3249L27.2621 15.1871C27.2621 15.1871 28.0681 23.032 56.3339 55.376L57.7726 54.0303L57.7658 54.023Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3034 58.1968C53.3034 58.1968 28.2972 31.4166 17.9546 27.5758L17.2657 25.5364C17.2657 25.5364 35.8988 36.1917 54.7422 56.8512L53.3034 58.1968Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M47.5023 43.7963C49.6428 45.1626 51.5751 45.9842 53.2356 46.4713C56.5796 50.3541 58.912 52.965 58.912 52.965L51.9884 59.4406C51.9884 59.4406 37.6224 44.7394 26.5288 35.4257C28.7221 34.5793 30.71 32.6789 34.1176 32.9697C39.1481 33.3855 40.2147 39.152 47.5019 43.8104L47.5023 43.7963Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4636 44.0102L59.1101 43.4413C57.3587 42.7107 55.3544 42.9832 53.8648 44.1574C51.3724 46.1188 47.4496 49.3907 44.3614 52.8815C43.0821 54.3245 42.6958 56.3563 43.3639 58.1686L43.8702 59.5298L60.4636 44.0102Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M55.1619 45.7786C52.6696 47.7399 48.7468 51.0119 45.6585 54.5027C44.5628 55.7467 44.1181 57.4086 44.4399 58.9971L43.7534 59.6392L43.2471 58.278C42.5789 56.4657 42.9653 54.4339 44.2446 52.9909C47.3401 49.4932 51.2556 46.2281 53.7479 44.2668C55.2376 43.0926 57.2418 42.82 58.9932 43.5507L60.3468 44.1195L59.6164 44.8026C58.0794 44.4328 56.4334 44.7811 55.1692 45.7718L55.1619 45.7786Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0733 44.5322L63.0359 43.891C61.5026 43.4081 59.8224 43.7199 58.5719 44.7251C55.4242 47.2447 49.2741 52.3807 44.7289 57.5492C43.6624 58.7658 43.2737 60.4437 43.7028 62.0004L44.2581 64.0142L65.0874 44.5326L65.0733 44.5322Z",
    fill: "#00FF9F",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9668 64.4567L88.095 55.1219C88.1457 51.4871 86.8837 47.971 84.5355 45.1969C80.1862 40.0636 72.7134 31.6492 66.3937 26.6198C64.7329 25.2979 62.3087 26.7025 62.6345 28.8076L65.0868 44.5467L87.9668 64.4567Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M65.1757 44.6415L62.7234 28.9025C62.3976 26.7974 64.8217 25.3927 66.4826 26.7147C67.7781 27.7485 69.1255 28.9256 70.4773 30.1806C69.1072 30.1065 67.794 31.2936 68.0452 32.8798L70.4976 48.6188L65.1757 44.6415Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6329 53.2055C58.5262 48.6288 64.9036 44.5263 64.9036 44.5263C64.9036 44.5263 104.8 77.0965 110.246 87.7213C115.685 98.353 112.105 115.723 112.105 115.723C112.105 115.723 94.5206 118.135 84.2833 111.991C74.046 105.847 44.0761 64.3758 44.0761 64.3758C44.0761 64.3758 48.7328 57.7749 53.6188 53.205L53.6329 53.2055Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.896 114.43C109.928 107.627 107.553 100.975 103.779 95.1533C99.874 89.4264 94.7308 84.7618 89.9952 79.7571C80.2737 70.0364 70.3837 60.487 60.2002 51.2532C69.8413 61.049 79.6734 70.639 89.3218 80.4279C94.0681 85.3269 99.1962 90.0193 103.171 95.5575C107.022 101.198 109.556 107.728 110.896 114.416L110.896 114.43Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3173 85.3921C77.9181 79.7567 84.2484 74.9451 90.3405 69.8496C83.6207 74.0397 77.101 79.0148 72.3173 85.3921Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9114 83.4597C90.9114 83.4597 89.718 80.8515 79.222 84.5616C68.7259 88.2718 68.3343 80.5186 68.3343 80.5186C68.3343 80.5186 76.296 83.8341 78.0158 82.3351C78.0158 82.3351 72.2329 79.241 69.1338 75.6494C66.0348 72.0578 52.5228 54.2439 52.5228 54.2439L43.98 64.2878C43.98 64.2878 48.025 66.4607 51.4723 70.8493C61.4211 83.5066 80.9158 109.02 84.9807 110.599C90.4497 112.714 103.811 117.059 110.683 115.506C110.683 115.506 91.3705 106.759 87.5978 101.73C83.8252 96.7006 90.9114 83.4597 90.9114 83.4597Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.963 115.174C107.963 115.174 95.6779 113.78 87.5139 106.778C79.35 99.777 68.1349 86.0585 68.1349 86.0585C68.1349 86.0585 84.6301 104.368 88.3561 106.347C92.0822 108.325 101.375 113.722 107.963 115.174Z",
    fill: "#A6A5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1001 59.7671C86.9138 54.4739 86.1925 47.9054 81.6821 44.4152C85.2829 48.6603 85.7548 54.4351 86.1001 59.7671Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.397 40.9841C64.5619 41.2038 64.8205 44.2618 65.5747 44.9804L73.2245 51.4905L87.9595 64.4635C87.9595 64.4635 74.2846 50.6769 70.1672 44.5326C69.1631 43.0345 67.7159 41.8824 66.0255 41.2316L65.3897 40.991L65.397 40.9841Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.564 113.052C111.564 113.052 112.667 95.9317 106.673 87.312C100.679 78.6923 81.2829 60.1652 81.2829 60.1652C81.2829 60.1652 97.3253 71.9155 105.828 83.8029C114.331 95.6902 111.984 101.993 111.572 113.045L111.564 113.052Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M82.935 83.759C86.8314 80.1147 92.9444 80.3191 96.5886 84.2155C100.233 88.1119 100.029 94.2249 96.1321 97.8692C92.2357 101.513 86.1227 101.309 82.4784 97.4127C78.8342 93.5163 79.0385 87.4033 82.935 83.759Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8557 70.2368C57.5696 69.569 58.6897 69.6065 59.3574 70.3204C60.0252 71.0344 59.9877 72.1545 59.2738 72.8222C58.5598 73.4899 57.4398 73.4525 56.772 72.7385C56.1043 72.0246 56.1417 70.9045 56.8557 70.2368Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8266 74.7014C60.1815 74.3694 60.7384 74.388 61.0704 74.743C61.4024 75.0979 61.3838 75.6548 61.0288 75.9868C60.6739 76.3188 60.117 76.3001 59.785 75.9452C59.453 75.5902 59.4716 75.0334 59.8266 74.7014Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4854 76.7949C57.7395 76.5573 58.1382 76.5706 58.3759 76.8247C58.6135 77.0788 58.6002 77.4775 58.3461 77.7152C58.092 77.9528 57.6933 77.9395 57.4556 77.6854C57.218 77.4313 57.2313 77.0326 57.4854 76.7949Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6732 85.6228C65.9072 85.404 66.2742 85.4163 66.493 85.6502C66.7118 85.8842 66.6995 86.2512 66.4656 86.47C66.2316 86.6888 65.8646 86.6766 65.6458 86.4426C65.427 86.2087 65.4393 85.8416 65.6732 85.6228Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7054 88.747C67.9958 88.4754 68.4515 88.4906 68.7231 88.781C68.9947 89.0715 68.9795 89.5271 68.6891 89.7987C68.3986 90.0703 67.943 90.0551 67.6714 89.7647C67.3998 89.4743 67.415 89.0186 67.7054 88.747Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4293 70.0288C83.9376 69.5535 84.7349 69.5802 85.2102 70.0884C85.6856 70.5966 85.6589 71.394 85.1507 71.8693C84.6425 72.3446 83.8451 72.318 83.3698 71.8097C82.8944 71.3015 82.9211 70.5042 83.4293 70.0288Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2435 67.6914C81.4976 67.4538 81.8963 67.4671 82.1339 67.7212C82.3716 67.9753 82.3583 68.374 82.1042 68.6117C81.85 68.8493 81.4514 68.836 81.2137 68.5819C80.976 68.3278 80.9894 67.9291 81.2435 67.6914Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M72.3173 85.3921C72.3173 85.3921 74.0283 80.136 73.8712 77.6403C73.7141 75.1447 73.6964 75.4625 75.9052 71.8219C78.1141 68.1814 79.4624 66.578 83.0244 67.7513C86.5863 68.9246 90.3405 69.8496 90.3405 69.8496L80.557 77.2201L72.3173 85.3921Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5966 38.317C73.1492 37.8001 74.0161 37.8291 74.533 38.3817C75.0498 38.9343 75.0208 39.8012 74.4682 40.3181C73.9156 40.8349 73.0487 40.8059 72.5318 40.2533C72.015 39.7007 72.044 38.8338 72.5966 38.317Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3026 39.9075C75.4962 39.7264 75.8 39.7366 75.981 39.9302C76.1621 40.1238 76.152 40.4276 75.9584 40.6086C75.7647 40.7897 75.461 40.7796 75.2799 40.586C75.0988 40.3923 75.109 40.0886 75.3026 39.9075Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3099 88.4532L52.9875 87.9576C49.3573 87.7654 45.9335 86.2713 43.3224 83.7431C38.4911 79.0607 30.5946 71.0424 25.9986 64.401C24.7905 62.6555 26.354 60.3306 28.4326 60.7963L43.9727 64.2944L62.3099 88.4532Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7557 86.2776C52.4587 85.5769 46.721 84.7271 42.7331 80.844C45.9143 85.5775 52.4199 86.736 57.7557 86.2776Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4331 72.0455C39.9857 71.5286 40.8527 71.5576 41.3695 72.1102C41.8864 72.6628 41.8574 73.5298 41.3048 74.0466C40.7522 74.5634 39.8852 74.5345 39.3684 73.9819C38.8515 73.4293 38.8805 72.5623 39.4331 72.0455Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8465 74.845C41.0401 74.6639 41.3439 74.6741 41.525 74.8677C41.7061 75.0613 41.6959 75.3651 41.5023 75.5461C41.3087 75.7272 41.0049 75.7171 40.8239 75.5235C40.6428 75.3299 40.6529 75.0261 40.8465 74.845Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M43.9519 64.4918L28.4119 60.9937C26.3332 60.528 24.7697 62.8529 25.9778 64.5984C26.9228 65.9601 28.0072 67.383 29.1691 68.8156C29.1867 67.4437 30.4589 66.2127 32.0247 66.5693L47.5648 70.0675L43.9519 64.4918Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M99.2394 101.85C94.7013 106.382 90.805 111.19 88.9637 113.994C88.3884 113.848 87.8205 113.694 87.2608 113.506C88.5958 111.244 91.7691 106.687 95.9199 102.312C96.543 101.661 97.1735 101.003 97.8249 100.353C102.114 96.0812 107.173 92.2671 111.429 90.4355C111.574 90.9851 111.696 91.5411 111.805 92.0966C107.756 94.0625 103.236 97.8521 99.2252 101.85L99.2394 101.85Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7761 107.167C100.167 106.801 100.781 106.822 101.147 107.213C101.513 107.604 101.493 108.218 101.101 108.584C100.71 108.95 100.096 108.929 99.7302 108.538C99.3643 108.147 99.3848 107.533 99.7761 107.167Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.063 107.474C100.285 107.266 100.633 107.278 100.84 107.5C101.048 107.722 101.036 108.07 100.814 108.277C100.593 108.485 100.245 108.473 100.037 108.251C99.8295 108.029 99.8412 107.681 100.063 107.474Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4099 111.356C96.8011 110.99 97.4149 111.011 97.7809 111.402C98.1468 111.793 98.1263 112.407 97.735 112.773C97.3438 113.139 96.73 113.118 96.364 112.727C95.9981 112.336 96.0186 111.722 96.4099 111.356Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6968 111.663C96.9187 111.455 97.2667 111.467 97.4742 111.689C97.6817 111.911 97.67 112.259 97.4482 112.466C97.2263 112.674 96.8783 112.662 96.6708 112.44C96.4633 112.218 96.475 111.87 96.6968 111.663Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.727 103.253C104.119 102.887 104.733 102.907 105.099 103.298C105.464 103.69 105.444 104.304 105.053 104.669C104.661 105.035 104.048 105.015 103.682 104.624C103.316 104.232 103.336 103.619 103.727 103.253Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.014 103.559C104.236 103.352 104.584 103.363 104.792 103.585C104.999 103.807 104.988 104.155 104.766 104.363C104.544 104.57 104.196 104.558 103.988 104.337C103.781 104.115 103.793 103.767 104.014 103.559Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.172 99.6017C108.564 99.2358 109.178 99.2563 109.543 99.6475C109.909 100.039 109.889 100.653 109.498 101.019C109.106 101.384 108.493 101.364 108.127 100.973C107.761 100.581 107.781 99.9676 108.172 99.6017Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.459 99.9083C108.681 99.7008 109.029 99.7125 109.237 99.9343C109.444 100.156 109.433 100.504 109.211 100.712C108.989 100.919 108.641 100.908 108.433 100.686C108.226 100.464 108.238 100.116 108.459 99.9083Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5747 44.9803C65.5747 44.9803 53.3404 52.6439 48.6153 60.0208",
    stroke: "#3F3D56",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M50.4185 51.5843L58.0175 45.011C58.1845 44.8821 58.3374 44.7528 58.4899 44.6376C59.6459 43.707 61.1569 43.3755 62.5891 43.7064C61.2949 46.2313 59.0816 49.3694 55.5389 51.2178C53.5949 52.2282 50.2419 53.2693 47.1053 54.82C48.1895 53.7101 49.3011 52.6294 50.418 51.5984L50.4185 51.5843Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4469 40.3813C41.4469 40.3813 52.0572 46.1626 64.824 59.8127C76.5594 72.36 75.9295 76.3858 75.7547 76.9601C75.7391 77.002 75.7094 77.0435 75.6802 77.0708C75.6802 77.0708 75.6076 77.125 75.5648 77.1377C74.9869 77.2811 70.9211 77.6334 59.1858 65.0861C46.419 51.436 41.3593 40.4633 41.3593 40.4633L41.4542 40.3745L41.4469 40.3813Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3916 57.3851C56.9402 57.7662 55.1478 56.9917 53.7698 56.3088C53.2826 56.0661 52.8091 56.6871 53.1847 57.0887C54.1547 58.1258 55.8894 59.146 58.7276 58.4768C61.523 57.8203 60.5331 59.7046 60.9453 60.0721L61.0751 60.2109C61.0751 60.2109 61.5606 60.7153 62.4298 60.9566C63.1377 61.1571 63.5659 61.8931 63.3863 62.6088C63.0097 64.1385 62.7244 66.7467 64.368 68.7969C66.1751 71.0364 72.4894 75.1671 75.8086 77.252C75.8086 77.252 75.7361 77.3061 75.6932 77.3189C75.1153 77.4623 71.0495 77.8145 59.3142 65.2672C46.5474 51.6172 41.4877 40.6444 41.4877 40.6444L41.5827 40.5556C41.5827 40.5556 41.7426 40.6388 42.0479 40.8188C43.9306 43.1245 50.3613 50.9664 52.0521 52.8766C54.0429 55.1223 57.392 57.3709 57.392 57.3709L57.3916 57.3851Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2135 63.6109C65.8508 63.0148 66.8507 63.0483 67.4468 63.6856C68.0428 64.3229 68.0094 65.3227 67.3721 65.9188C66.7348 66.5148 65.7349 66.4814 65.1389 65.8441C64.5428 65.2068 64.5762 64.207 65.2135 63.6109Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M75.526 76.8178C75.526 76.8178 75.4807 76.9012 75.4515 76.9285C75.4223 76.9559 75.379 76.9827 75.3361 76.9954C75.0082 77.0694 73.5599 77.219 70.2362 75.0562C70.279 75.0434 70.3151 75.0234 70.3443 74.9961C70.3808 74.9619 70.4032 74.9273 70.4187 74.8854C70.6004 74.3184 71.2235 70.2852 59.4881 57.738C52.6436 50.4199 46.4239 45.3656 42.1132 42.25C41.4399 41.0176 41.1302 40.3351 41.1302 40.3351L41.2251 40.2463C41.2251 40.2463 51.8353 46.0276 64.6022 59.6777C76.3375 72.225 75.7077 76.2508 75.5328 76.8251L75.526 76.8178Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.321 67.5907C65.563 67.3643 65.9427 67.377 66.1691 67.6191C66.3954 67.8611 66.3827 68.2407 66.1407 68.4671C65.8987 68.6935 65.519 68.6808 65.2927 68.4387C65.0663 68.1967 65.079 67.817 65.321 67.5907Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5717 67.1425C67.7774 66.9501 68.1002 66.9609 68.2926 67.1666C68.485 67.3723 68.4742 67.6951 68.2685 67.8875C68.0628 68.0799 67.74 68.0691 67.5476 67.8634C67.3552 67.6577 67.366 67.3349 67.5717 67.1425Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9495 72.4934C60.3196 67.9965 55.7519 62.4102 51.3787 56.7242C55.1656 62.808 59.8903 68.5623 65.9495 72.4934Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M80.4412 57.8306C80.4412 57.8306 82.9215 63.0005 79.5301 61.8046C76.1387 60.6087 77.6542 59.9307 72.4479 57.3652C67.2415 54.7998 69.2777 53.3609 66.7509 51.2742C64.2242 49.1875 63.8154 52.1029 61.9082 52.4353C60.001 52.7677 57.8179 53.098 56.8741 51.4887C55.9304 49.8794 66.3419 45.5227 66.3419 45.5227L80.4339 57.8374L80.4412 57.8306Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6083 52.1595C63.9269 51.8614 64.4269 51.8781 64.7249 52.1968C65.0229 52.5154 65.0062 53.0154 64.6876 53.3134C64.3689 53.6114 63.869 53.5947 63.571 53.2761C63.2729 52.9574 63.2896 52.4575 63.6083 52.1595Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0979 57.1208C68.2027 57.0228 68.3673 57.0283 68.4654 57.1331C68.5634 57.238 68.5579 57.4025 68.4531 57.5006C68.3482 57.5987 68.1837 57.5932 68.0856 57.4883C67.9875 57.3835 67.993 57.2189 68.0979 57.1208Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9132 78.1295L84.8276 78.7846L85.1406 79.3682C85.2871 79.6419 85.0637 79.9741 84.7537 79.9354L84.0986 79.8498L83.5151 80.1628C83.2413 80.3093 82.9092 80.086 82.9479 79.776L83.0334 79.1209L82.7204 78.5373C82.5739 78.2636 82.7973 77.9314 83.1073 77.9701L83.7624 78.0557L84.3459 77.7427C84.6197 77.5962 84.9518 77.8195 84.9132 78.1295Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6443 79.0551C80.9307 78.7872 81.3799 78.8022 81.6478 79.0886C81.9157 79.375 81.9006 79.8243 81.6142 80.0922C81.3279 80.36 80.8786 80.345 80.6107 80.0586C80.3429 79.7722 80.3579 79.3229 80.6443 79.0551Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0354 29.3661C30.6122 28.8266 31.5171 28.8568 32.0565 29.4336C32.596 30.0104 32.5658 30.9154 31.989 31.4548C31.4122 31.9943 30.5072 31.9641 29.9678 31.3873C29.4283 30.8105 29.4586 29.9055 30.0354 29.3661Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8839 32.0599C32.0815 31.8751 32.3916 31.8854 32.5765 32.0831C32.7613 32.2807 32.7509 32.5908 32.5533 32.7756C32.3557 32.9605 32.0456 32.9501 31.8607 32.7525C31.6759 32.5548 31.6862 32.2448 31.8839 32.0599Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7833 40.841C37.3077 40.3506 38.1303 40.3781 38.6207 40.9025C39.1112 41.4268 39.0837 42.2495 38.5593 42.7399C38.0349 43.2304 37.2123 43.2028 36.7219 42.6785C36.2314 42.1541 36.2589 41.3315 36.7833 40.841Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6935 40.9199C34.8629 40.7615 35.1287 40.7704 35.2872 40.9398C35.4456 41.1092 35.4367 41.375 35.2673 41.5334C35.0979 41.6919 34.8321 41.683 34.6737 41.5136C34.5152 41.3442 34.5241 41.0784 34.6935 40.9199Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4487 37.574C44.602 37.4307 44.8424 37.4387 44.9858 37.592C45.1292 37.7453 45.1211 37.9857 44.9678 38.1291C44.8146 38.2725 44.5741 38.2644 44.4307 38.1111C44.2874 37.9579 44.2954 37.7174 44.4487 37.574Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5864 36.4909C43.6832 36.4003 43.8351 36.4054 43.9256 36.5022C44.0162 36.599 44.0111 36.7509 43.9143 36.8414C43.8175 36.932 43.6656 36.9269 43.5751 36.8301C43.4845 36.7333 43.4896 36.5814 43.5864 36.4909Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6441 85.615C87.5405 81.9707 93.6535 82.1751 97.2978 86.0715C100.942 89.9679 100.738 96.0809 96.8412 99.7252C92.9448 103.369 86.8318 103.165 83.1876 99.2686C79.5433 95.3722 79.7477 89.2593 83.6441 85.615Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9724 85.9514C87.6994 82.4655 93.5466 82.661 97.0324 86.388C100.518 90.1151 100.323 95.9622 96.5958 99.4481C92.8688 102.934 87.0216 102.738 83.5357 99.0114C80.0499 95.2844 80.2454 89.4372 83.9724 85.9514Z",
    stroke: "#04DAF6",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2829 98.088C95.5451 97.8428 95.9564 97.8565 96.2016 98.1187C96.4468 98.3809 96.4331 98.7922 96.1709 99.0374C95.9087 99.2827 95.4974 99.2689 95.2522 99.0067C95.0069 98.7445 95.0207 98.3332 95.2829 98.088Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2852 86.3297C84.5474 86.0845 84.9587 86.0982 85.2039 86.3604C85.4491 86.6226 85.4354 87.0339 85.1732 87.2791C84.911 87.5244 84.4997 87.5106 84.2545 87.2484C84.0093 86.9862 84.023 86.5749 84.2852 86.3297Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6634 86.7101C95.9256 86.4649 96.3369 86.4786 96.5821 86.7408C96.8273 87.003 96.8136 87.4143 96.5514 87.6595C96.2892 87.9047 95.8779 87.891 95.6327 87.6288C95.3874 87.3666 95.4012 86.9553 95.6634 86.7101Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9048 97.7076C84.167 97.4624 84.5783 97.4762 84.8236 97.7383C85.0688 98.0005 85.055 98.4119 84.7928 98.6571C84.5307 98.9023 84.1193 98.8885 83.8741 98.6264C83.6289 98.3642 83.6426 97.9528 83.9048 97.7076Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8265 92.4781C98.0886 92.2329 98.5 92.2467 98.7452 92.5089C98.9904 92.771 98.9766 93.1824 98.7145 93.4276C98.4523 93.6728 98.041 93.659 97.7957 93.3969C97.5505 93.1347 97.5643 92.7234 97.8265 92.4781Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7417 91.94C82.0039 91.6948 82.4153 91.7086 82.6605 91.9708C82.9057 92.233 82.8919 92.6443 82.6298 92.8895C82.3676 93.1347 81.9562 93.121 81.711 92.8588C81.4658 92.5966 81.4796 92.1853 81.7417 91.94Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.053 84.1666C90.3152 83.9214 90.7265 83.9352 90.9717 84.1973C91.217 84.4595 91.2032 84.8708 90.941 85.1161C90.6788 85.3613 90.2675 85.3475 90.0223 85.0853C89.7771 84.8232 89.7908 84.4118 90.053 84.1666Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5152 100.252C89.7774 100.006 90.1887 100.02 90.4339 100.282C90.6791 100.544 90.6654 100.956 90.4032 101.201C90.141 101.446 89.7297 101.432 89.4845 101.17C89.2392 100.908 89.253 100.497 89.5152 100.252Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8094 87.9302C88.4272 85.4818 92.5341 85.6192 94.9825 88.2369C97.4309 90.8547 97.2936 94.9617 94.6758 97.4101C92.058 99.8584 87.9511 99.7211 85.5027 97.1033C83.0543 94.4856 83.1916 90.3786 85.8094 87.9302Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.59,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.528 96.2571L84.0012 94.4001C83.6955 93.3852 83.6466 92.3082 83.8439 91.2747L96.6585 93.3375C96.5251 94.366 96.1519 95.3723 95.528 96.2571Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7062 92.7589L83.9832 90.7063C84.0473 90.482 84.1256 90.2582 84.2175 90.049L96.6943 92.0581C96.7077 92.292 96.7143 92.5186 96.7062 92.7589Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M92.5115 88.0834C87.0834 88.7651 84.9423 88.2619 83.3712 91.662C82.3797 93.808 82.1629 96.2699 82.1333 97.79C79.8348 93.9564 80.428 88.9105 83.8314 85.7273C87.6291 82.1753 93.5337 82.2666 97.2196 85.8707C96.4242 86.8063 95.0055 87.7636 92.5046 88.0761L92.5115 88.0834Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.771 92.0598C112.162 93.4737 112.46 94.9341 112.666 96.4125C109.181 97.5766 106.391 99.9949 101.544 104.432C96.9393 108.643 93.546 113.638 92.9355 115.181C91.5092 114.886 90.0993 114.52 88.7352 114.057C90.1703 111.551 93.7954 105.97 98.6818 101.386C103.918 96.488 107.66 93.7548 111.757 92.0593L111.771 92.0598Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M100.076 102.862C95.7568 107.189 92.0649 111.805 90.3478 114.493C89.7872 114.333 89.2265 114.173 88.6741 113.977C89.9215 111.797 92.9049 107.419 96.8585 103.228C97.4524 102.604 98.0537 101.973 98.6759 101.35C102.76 97.2701 107.6 93.6609 111.703 91.9728C111.855 92.5156 111.992 93.0579 112.108 93.6065C108.206 95.4358 103.89 99.0342 100.069 102.854L100.076 102.862Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1023_9909",
    x1: 35.8101,
    y1: 165.722,
    x2: 208.753,
    y2: 165.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E26438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#DD6337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CF6136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#B85E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF5D35"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1023_9909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(370.464 226.906) rotate(-120.96) scale(340.448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F1A21F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E9A134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C07F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DB8649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9B6D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_9909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.53,
    height: 131.94,
    fill: "white",
    transform: "matrix(0.730341 -0.683082 -0.683082 -0.730341 91.1259 135.659)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupiter);
export default __webpack_public_path__ + "static/media/jupiter.0ab58805b1eefb722c0d06b0e5cc9893.svg";
export { ForwardRef as ReactComponent };